module.exports = __webpack_public_path__ + "img/DE01167.6135f5c4.png";